import * as types from './types';

const initialState = {
    brands: []
};

export default function mainBrandsReducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_MAIN_BRANDS:
            return {
                ...state,
                brands: action.payload
            };
        case types.CLEAR_MAIN_BRANDS:
            return {
                ...state,
                brands: []
            };
        default:
            return state;
    }
} 